import axios from 'axios';
import { httpClient } from '../providers/AppDataProvider';
import { sanitizeUploadFilename } from 'src/utils/upload-filename';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const cacheControl = process.env.REACT_APP_CDN_CACHE_CONTROL

export const getFileType = (mimeType: string): string => {
  if (mimeType.startsWith('image/')) return 'IMAGE';
  if (mimeType.startsWith('video/')) return 'VIDEO';
  return 'DOCUMENT';
};

export const getMimeType = (file: File): string => {
  if(file.name.endsWith('.apk')) return 'APPLICATION_APK';
  const map: Record<string, string> = {
    'image/jpeg': 'IMAGE_JPEG',
    'image/png': 'IMAGE_PNG',
    'image/gif': 'IMAGE_GIF',
    'image/webp': 'IMAGE_WEBP',
    'image/svg+xml': 'IMAGE_SVG_XML',
    'video/mp4': 'VIDEO_MP4',
    'video/quicktime': 'VIDEO_QUICKTIME',
    'video/x-msvideo': 'VIDEO_X_MSVIDEO',
    'video/webm': 'VIDEO_WEBM',
    'application/vnd.android.package-archive': 'APPLICATION_APK',
  }
  const result = map[file.type];
  if(!result) throw new Error(`module.cdnUpload.unsupportedFileType`);
  return result
}

export const uploadToSignedUrl = async (signedUrl: string, file: File, onProgress?: (percent: number) => void, signal?: AbortSignal) => {
  await axios.put(signedUrl, file, {
    headers: {
      'Content-Type': file.type,
      'Cache-Control': cacheControl,
    },
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        const percent = Math.round((event.loaded * 100) / event.total);
        onProgress(percent);
      }
    },
    signal,
  });
};

export const getSignedUrl = async (params: {
  filename: string;
  fileType: string;
  mimeType: string;
  size: number;
  pathPrefix?: string;
  customFilename?: string;
  usePrivateBucket?: boolean;
}) => {
  const query = new URLSearchParams({
    filename: sanitizeUploadFilename(params.filename),
    fileType: params.fileType,
    mimeType: params.mimeType,
    size: String(params.size),
    ...(params.pathPrefix && {pathPrefix: sanitizeUploadFilename(params.pathPrefix)}),
    ...(params.customFilename && {customFilename: sanitizeUploadFilename(params.customFilename)}),
    ...(params.usePrivateBucket !== undefined && {usePrivateBucket: String(params.usePrivateBucket)})
  }).toString();
  const {json} = await httpClient(`${baseUrl}/publishing/cdn-uploads/getSignedUrl?${query}`)
  return json?.data ?? json;
};

export const getMimeTypeSafe = (file: File): string => {
  try {
    return getMimeType(file);
  } catch {
    return file.type || 'application/octet-stream';
  }
};

export const getDownloadUrl = async (fileId: string) => {
  const { json } = await httpClient(
    `${baseUrl}/publishing/cdn-uploads/getDownloadUrl/${fileId}`
  );
  return json?.data ?? json;
}